import { useState } from "react";

import useCart from "@/src/hooks/useCart";
import useUser from "@/src/hooks/useUser";
import Image from "next/image";
import Link from "next/link";
import { Button, Input } from "reactstrap";

interface PropsCart {
  position: string;
  cartDisplay: string;
}

export default function ShoppingCart({ position, cartDisplay }: PropsCart) {
  const [openSide, setOpenSide] = useState(false);

  const { cart, removeFromCart, increaseQuantityF, decreaseQuantityF } =
    useCart();

  const fixTitle = (name: string) => {
    return name
      .replace(/\s+/g, "_")
      .replace(/,/g, "_")
      .replace(/\//g, "_")
      .replace(/\(/g, "_")
      .replace(/\+/g, "_")
      .replace(/\*/g, "_")
      .replace(/\)/g, "_")
      .replace(/:/g, "_")
      .replace(/'/g, "_")
      .replace(/-/g, "_")
      .replace(/__/g, "_")
      .toLowerCase();
  };
  const { userData } = useUser();
  const isLogin = userData.isLogin;

  return (
    <>
      {/* {layout === "layout3" ? (
        <li
          className="mobile-cart cart-hover-div"
          onClick={() => {
            setOpenSide(true);
            document.body.style.overflow = "hidden";
          }}
        >
          <a href="#">
            <span className="cart-item">{cart.totalQuantity}</span>
            <i className="icon-shopping-cart"></i>
          </a>
        </li>
      ) : (
        
      )} */}
      <div
        className="cart-block cart-hover-div"
        onClick={() => {
          setOpenSide(true);
          document.body.style.overflow = "hidden";
        }}
      >
        <div className="cart ">
          <span className="cart-product"> {cart.totalQuantity} </span>
          <ul>
            <li className="mobile-cart">
              <a href="#">
                <i className="icon-shopping-cart "></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        id="cart_side"
        className={`add_to_cart ${position} ${openSide ? "open-side" : ""} `}
      >
        <Button
          className="overlay"
          onClick={() => {
            setOpenSide(false);
            document.body.style.overflow = "visible";
          }}
        ></Button>
        <div className="cart-inner">
          <div className="cart_top">
            <h3>Mi Carrito </h3>
            <div
              className="close-cart"
              onClick={() => {
                setOpenSide(false);
                document.body.style.overflow = "visible";
              }}
            >
              <a href="#">
                <i className="fa fa-times"></i>
              </a>
            </div>
          </div>
          <div className="cart_media">
            <ul className="cart_product">
              {cart.items.length > 0 ? (
                cart.items.map((item, index) => (
                  <li key={`cart-popup-${index}`}>
                    <div className="media d-flex align-items-center">
                      <div className="media-left me-3">
                        <Link
                          href={`producto/${item.id_product}/${fixTitle(
                            item.name
                          )}`}
                        >
                          <Image
                            alt={`${item.name}`}
                            src={`${item.image}`}
                            width={90}
                            height={90}
                          />
                        </Link>
                      </div>

                      <div className="media-body">
                        <div className="title_cart">
                          <Link
                            href={`producto/${item.id_product}/${fixTitle(
                              item.name
                            )}`}
                          >
                            <h4>
                              {item.name.length > 20
                                ? `${item.name.substring(0, 20)}...`
                                : item.name}
                            </h4>
                            <h4>
                              <span>
                                {item.quantity} x $ {item.price}
                              </span>
                            </h4>
                          </Link>
                        </div>

                        <div className="quantity-controls">
                          <button
                            className="minus"
                            onClick={() => {
                              decreaseQuantityF(item.id_product);
                            }}
                          >
                            <i className="fa fa-minus"></i>
                          </button>
                          <Input
                            type="text"
                            name="quantity"
                            value={item.quantity}
                            readOnly
                          />
                          <button
                            className="plus"
                            onClick={() => {
                              increaseQuantityF(item.id_product);
                            }}
                          >
                            <i className="fa fa-plus"></i>
                          </button>
                        </div>
                        <div className="remove">
                          <Button
                            onClick={() => removeFromCart(item.id_product)}
                          >
                            <i className="ti-trash"></i>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </li>
                ))
              ) : (
                <h3>Sin productos en el Carrito</h3>
              )}
            </ul>
            {!!cart.items.length && (
              <ul className="cart_total">
                <li>
                  <div className="total">
                    <h5>
                      Subtotal : <span>$ {cart.total}</span>
                    </h5>
                  </div>
                </li>
                <li>
                  <div className="buttons">
                    <Link
                      href="/carrito"
                      className="btn btn-normal btn-xs view-cart"
                      onClick={() => {
                        document.body.style.overflow = "visible";
                        setOpenSide(false);
                      }}
                    >
                      Ver carrito
                    </Link>
                    {isLogin ? (
                      <Link
                        href="/comprar"
                        className="btn btn-normal btn-xs checkout"
                        onClick={() => {
                          document.body.style.overflow = "visible";
                          setOpenSide(false);
                        }}
                      >
                        Finalizar Compra
                      </Link>
                    ) : (
                      <Link
                        href="/login"
                        className="btn btn-normal btn-xs checkout"
                        onClick={() => {
                          document.body.style.overflow = "visible";
                          setOpenSide(false);
                        }}
                      >
                        Finalizar Compra
                      </Link>
                    )}
                  </div>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
